import FinetuneSuggestionService from '@modules/Policy/services/FinetuneSuggestion.service';

// Auto-finetune metadata is deployment-wide configuration, not customer-specific.
// Cache the resolved value and share an in-flight request to avoid repeated API calls.
let cachedMetadata = null;
let metadataRequest = null;

/**
 * Loads the defaults, validation limits, and job-status definitions used by
 * auto-finetune forms, validation helpers, job lists, and polling behavior.
 */
export function fetchAutoFinetuneMetadata() {
  if (cachedMetadata) return Promise.resolve(cachedMetadata);
  if (metadataRequest) return metadataRequest;

  metadataRequest = FinetuneSuggestionService.fetchMetadata()
    .then((metadata) => {
      cachedMetadata = metadata;
      return metadata;
    })
    .catch((error) => {
      metadataRequest = null;
      throw error;
    });

  return metadataRequest;
}
